import { render, staticRenderFns } from "./PublishingCompanyForm.vue?vue&type=template&id=4d2de192"
import script from "./PublishingCompanyForm.vue?vue&type=script&lang=js"
export * from "./PublishingCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports